/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Returns__Legal_WarrantyInputs */

const en_help_center__refund_policy__returns__legal_warranty = /** @type {((inputs: Help_Center__Refund_Policy__Returns__Legal_WarrantyInputs) => LocalizedString) & { parts: (inputs: Help_Center__Refund_Policy__Returns__Legal_WarrantyInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Refund_Policy__Returns__Legal_WarrantyInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Legal Warranty: Legal warranty conditions apply to all products.`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Refund_Policy__Returns__Legal_WarrantyInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "Legal Warranty:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " Legal warranty conditions apply to all products." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Legal Warranty: Legal warranty conditions apply to all products." |
*
* @param {Help_Center__Refund_Policy__Returns__Legal_WarrantyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__returns__legal_warranty = /** @type {((inputs?: Help_Center__Refund_Policy__Returns__Legal_WarrantyInputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Refund_Policy__Returns__Legal_WarrantyInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Returns__Legal_WarrantyInputs, { locale?: "en" }, { strong: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Refund_Policy__Returns__Legal_WarrantyInputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__refund_policy__returns__legal_warranty(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Refund_Policy__Returns__Legal_WarrantyInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__refund_policy__returns__legal_warranty.parts === "function" ? en_help_center__refund_policy__returns__legal_warranty.parts(inputs) : [{ type: "text", value: en_help_center__refund_policy__returns__legal_warranty(inputs) }]
			})
		}
	)
);